core.filter('visitStatusFilter', ['$translate', function ($translate) {
    return function (input) {
        if(input) {
            return $translate.instant('T.ENUM.VISIT_STATUS.' + input);
        } else {
            return ''
        }
    };
}]);